import { useEffect, useState } from "react";
import { useMobxStores } from "../../stores/stores";
import {
  Tooltip,
  Row,
  Button,
  Typography,
  Input,
  ConfigProvider,
  Modal,
} from "antd";
import { keycloak } from "../../utils/keycloak";
import { CheckOutlined, EditOutlined, HeartFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { OwnersModal } from "./modals/OwnersModal";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { observer } from "mobx-react";

const ItemDetailsPageDescription = ({ marketplaceItem, nft }) => {
  const { marketplaceStore, styleStore, userStore } = useMobxStores();
  const [editingDescription, setEditingDescription] = useState(false);
  const [description, setDescription] = useState(
    marketplaceStore.marketplaceItem?.item.description ?? "",
  );
  const [showOwnersModal, setShowOwnersModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setDescription(marketplaceItem?.description);
  }, [marketplaceItem]);

  const onUsernameClick = (username) => {
    navigate(`../../portfolio/${username}`);
  };

  const onAddtoWishlist = (id) => {
    let values = marketplaceStore.wishlist;
    values.items.push(id);
    marketplaceStore.UpdateWishlist(values);
  };

  const onRemoveFromWishlist = (id) => {
    let values = marketplaceStore.wishlist;
    for (let i = 0; i < values.items.length; i++) {
      if (values.items[i] === id) {
        values.items.splice(i, 1);
        break;
      }
    }
    marketplaceStore.UpdateWishlist(values);
  };

  const handleUpdateDescription = () => {
    marketplaceStore.UpdateMarketplaceItem(marketplaceItem?.id, {
      description: description,
    });
    setEditingDescription(false);
  };

  const renderOwners = () => {
    if (!marketplaceItem?.nft) {
      return null;
    }
    if (marketplaceItem?.nft) {
      if (marketplaceStore.ownership.length > 1) {
        return (
          <>
            <button
              onClick={() => setShowOwnersModal(true)}
              className="owners-button"
            >
              owners
            </button>
            <OwnersModal
              isOpen={showOwnersModal}
              handleClose={() => setShowOwnersModal(false)}
            />
          </>
        );
      } else {
        return (
          <>
            <Typography className="white-text">owned by</Typography>
            <Typography
              onClick={() =>
                onUsernameClick(
                  //   marketplaceItem?.nft
                  //     ? nft?.creator_name
                  //     : marketplaceItem?.owner_name
                  // )
                  marketplaceStore?.ownership[0]?.owner_username,
                )
              }
              className="blue-text"
            >
              @{marketplaceStore?.ownership[0]?.owner_username}
            </Typography>
          </>
        );
      }
    } else {
      return (
        <>
          <Typography className="white-text">owned by</Typography>
          <Typography
            onClick={() =>
              onUsernameClick(
                //   marketplaceItem?.nft
                //     ? nft?.creator_name
                //     : marketplaceItem?.owner_name
                // )
                marketplaceItem?.owner_name,
              )
            }
            className="blue-text"
          >
            @{marketplaceItem?.owner_name}
          </Typography>
        </>
      );
    }
  };

  return (
    <div className="gradient-background">
      <div style={{ position: "absolute", right: "24px", top: "24px" }}>
        <Tooltip
          title={
            marketplaceStore.wishlist.items.includes(marketplaceItem?.id)
              ? "Remove this item from your wishlist!"
              : "Add this item to your wishlist!"
          }
        >
          <HeartFilled
            onClick={(e) => {
              e.stopPropagation();
              if (keycloak.authenticated) {
                marketplaceStore.wishlist.items.includes(marketplaceItem?.id)
                  ? onRemoveFromWishlist(marketplaceItem?.id)
                  : onAddtoWishlist(marketplaceItem?.id);
              } else {
                Modal.confirm({
                  title: "Sign in required",
                  content:
                    "You are not allowed to perform this action. You need to sign in first.",
                  okText: "Sign in",
                  cancelText: "Cancel",
                  onOk: () =>
                    keycloak.login({ redirectUri: window.location.href }),
                });
              }
            }}
            className="heart-icon"
            style={{
              color: marketplaceStore.wishlist.items.includes(
                marketplaceItem?.id,
              )
                ? styleStore.primaryColor
                : "#c3c2c2",
            }}
          />
        </Tooltip>
      </div>
      {marketplaceItem?.description && (
        <Row
          className="spacing-bottom"
          style={{ maxWidth: "95%", display: "flex", gap: "8px" }}
        >
          {editingDescription ? (
            <Input.TextArea
              autoSize
              className="description-text"
              style={{ color: "#000080", maxWidth: "90%" }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          ) : (
            <ReactMarkdown
              components={{
                h1: ({ node, ...props }) => (
                  <Typography.Title
                    level={1}
                    {...props}
                    style={{ color: "white" }}
                  />
                ),
                h2: ({ node, ...props }) => (
                  <Typography.Title
                    level={2}
                    {...props}
                    style={{ color: "white" }}
                  />
                ),
                h3: ({ node, ...props }) => (
                  <Typography.Title
                    level={3}
                    {...props}
                    style={{ color: "white" }}
                  />
                ),
                h4: ({ node, ...props }) => (
                  <Typography.Title
                    level={4}
                    {...props}
                    style={{ color: "white" }}
                  />
                ),
                p: ({ node, ...props }) => (
                  <Typography className="description-text" {...props} />
                ),
                code({ node, inline, className, children, ...props }) {
                  const match = /language-(\w+)/.exec(className || "");
                  return !inline && match ? (
                    <SyntaxHighlighter
                      className="syntax-highlighter"
                      codeTagProps={{
                        style: {
                          textShadow: "none",
                        },
                      }}
                      language={match[1]}
                      PreTag="div"
                      {...props}
                    >
                      {String(children).replace(/\n$/, "")}
                    </SyntaxHighlighter>
                  ) : (
                    <code {...props}>{children}</code>
                  );
                },
              }}
            >
              {description}
            </ReactMarkdown>
          )}
          {!!userStore.user?.username &&
            (marketplaceStore.NFT?.creator_user === userStore.user?.username ||
              marketplaceItem?.owner_name === userStore.user?.username) && (
              <ConfigProvider wave={{ disabled: true }}>
                <Button
                  className="simple-button-edit"
                  icon={
                    editingDescription ? (
                      <CheckOutlined className="edit-button" />
                    ) : (
                      <EditOutlined className="edit-button" />
                    )
                  }
                  onClick={() =>
                    editingDescription
                      ? handleUpdateDescription()
                      : setEditingDescription(true)
                  }
                />
              </ConfigProvider>
            )}
        </Row>
      )}
      <Row className="medium-row-gap">
        <Row className="small-row-gap">
          <Typography className="white-text">created by</Typography>
          <Typography
            onClick={() =>
              onUsernameClick(
                marketplaceItem?.nft
                  ? nft?.creator_name
                  : marketplaceItem?.owner_name,
              )
            }
            className="blue-text"
          >
            @
            {marketplaceItem?.nft
              ? nft?.creator_name
              : marketplaceItem?.owner_name}
          </Typography>
        </Row>
        <Row className="flex-row small-row-gap">{renderOwners()}</Row>
      </Row>
    </div>
  );
};

export default observer(ItemDetailsPageDescription);
